module.exports = __webpack_public_path__ + "img/tanhuang2.prt.c9f9bf96.jpg";